// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3SHoH","footerLabel":"Footer_footerLabel__2pOiq"};